<template>
    <div class="h-100 content__page">
        <PageSpinner />
    </div>
</template>

<script>
import { PageSpinner } from "@/components/ui/index";

export default {
    name: "AuthHandlerView",

    components: {
        PageSpinner,
    },

    data() {
        return {
            pageLoading: true,
            pageErr: false,
            pageErrMsg: "",
            authType: "",
            providerKey: "",
            code: "",
        };
    },

    watch: {
        "pageErr": {
            async handler(newVal) {
                if (newVal) {
                    this.handlePageRedirect();
                }
            },
            immediate: true,
        },
    },

    async mounted() {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const redirect_uri = params.get("redirect_uri");
        const providerKey = localStorage.getItem("z:i_p") || "";
        
        this.authType = localStorage.getItem("z:auth_type") || "";

        if (this.$route.query.error) {
            this.pageErr = true;
        }
        
        if (code || redirect_uri) {
            this.code = redirect_uri || code;
        } 

        if (providerKey) {
            this.providerKey = providerKey;
        }

        await this.handleConnectResponse();
    },

    methods: {
        handlePageRedirect() {
            localStorage.removeItem("z:auth_type"); 
            
            if (this.authType === "integration") {
                localStorage.removeItem("z:integration_provider");
                localStorage.removeItem("z:integration_provider_id");  
                localStorage.removeItem("z:i_p");
                
                this.$router.push("/dashboard/settings/integrations");
            }

            if (this.authType === "meeting") {
                localStorage.removeItem("z:m_p");
                this.$router.push("/dashboard/meetings");
            }
        },

        async onIntegrationContinue() {
            try {
                const payload = {
                    key: this.providerKey, 
                    code: this.code, 
                    refreshToken: false,
                };

                await this.$store.dispatch("integration/enableIntegration", payload);
            } catch (error) {
                throw error;
            }
        },

        async onMeetingContinue() {
            try {
                await this.$store.dispatch("integration/enableIntegration", {
                    key: "google_calendar",
                    code: this.code,
                    refreshToken: true,
                });

                const payload = localStorage.getItem("z:m_p");
                await this.$store.dispatch("meeting/addMeeting", { payload });
            } catch (error) {
                throw error;
            }
        },

        async handleConnectResponse() {
            try {
                this.pageErr = false;
                this.pageLoading = true;

                if (this.authType === "integration") {
                    await this.onIntegrationContinue();
                }

                if (this.authType === "meeting") {
                    await this.onMeetingContinue();
                }

                this.handlePageRedirect();
            } catch (error) {
                this.pageErr = true;
                const errMsg = error?.response?.data?.message || error.message;
                this.$toast.error(errMsg);
            } finally {
                this.pageLoading = false;
            }
        },
    },
};
</script>